import { direction, setState } from '@/commonTypes';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

type ViewMode = 'grid' | 'list';

type Props = {
  direction?: direction;
  setDirection?: setState<direction>;
  className?: string;
};

export default function ViewToggle({ direction, setDirection, className = '' }: Props) {
  return (
    <div className={`${styles.container} ${className}`}>
      <div
        aria-label="Grid View"
        className={`${styles.button} ${direction === 'vertical' ? styles.active : ''}`}
        onClick={() => setDirection && setDirection('vertical')}
      >
        <MainIcons.gridIcon
          width="17px"
          height="17px"
          fill={direction === 'vertical' ? 'var(--accent)' : 'var(--text-mut)'}
        />
      </div>

      <div
        aria-label="List View"
        className={`${styles.button} ${direction === 'horizontal' ? styles.active : ''}`}
        onClick={() => setDirection && setDirection('horizontal')}
      >
        <MainIcons.listIcon
          width="17px"
          height="17px"
          fill={direction === 'horizontal' ? 'var(--accent)' : 'var(--text-mut)'}
        />
      </div>
    </div>
  );
}
